export default {
  root: ({ context }) => ({
    class: [
      // Font
      'font-sans leading-none',

      // Spacing
      'm-0 p-3',

      // Colors
      'text-secondary-600 dark:text-secondary-200',
      'placeholder:text-secondary-400 dark:placeholder:text-secondary-500',
      'bg-secondary-0 dark:bg-secondary-900',
      'border border-secondary-300 dark:border-secondary-600',

      // States
      {
        'hover:border-primary-500 dark:hover:border-primary-400': !context.disabled,
        'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-500/50 dark:focus:ring-primary-400/50':
          !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled
      },

      // Misc
      'rounded-md',
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
};
